import styled from "styled-components";

export const BreadcrumbContainer = styled.div`
    margin-left: 20px;
`;